import React, { Fragment } from 'react'
import { BulkDeleteButton, Datagrid, DeleteButton, List, TextField, translate } from 'react-admin'
import { AssetCustomFieldListActions } from './AssetCustomFieldListActions'

const PostBulkActionButtons = (props) => (
  <Fragment>
    <BulkDeleteButton disabled={!props.permissions?.includes('delete:assets')} {...props} />
  </Fragment>
)

const AssetCustomFieldList = ({ accessible, dispatch, permissions, ...props }) => {
  return (
    <List
      bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      actions={<AssetCustomFieldListActions />}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="type" />
        {permissions?.includes('delete:assets') && <DeleteButton />}
      </Datagrid>
    </List>
  )
}

export default translate(AssetCustomFieldList)
